import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";

import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";

const service = new Service();

export const UPDATE_USER_OK = "UPDATE_USER_OK";
export const UPDATE_USER_ERR = "UPDATE_USER_ERR";

export function updateUserOk(payload) {
  return {
    type: UPDATE_USER_OK,
    payload,
  };
}

export function updateUserErr(payload) {
  return {
    type: UPDATE_USER_ERR,
    payload,
  };
}

export const updateUserService = {
  updateUser,
};

function updateUser(params) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .post(ApiUrl.UpdateUserAccount, params)
      .then((response) => {
        dispatch(updateUserOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(updateUserErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        var message = JSON.stringify(error.errors);
        ShowNotification(message, NotificationMessageType.Error);
      });
  };
}
